// You can write more code here

import { ShopTabController } from '@/game/prefabs/CosmeticShop/ShopTabController';

/* START OF COMPILED CODE */

export default class ShopTab_m extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// tabBacking
		const tabBacking = scene.add.image(0, 0, "shop-tab-m");
		tabBacking.scaleX = 2;
		tabBacking.scaleY = 2;
		this.add(tabBacking);

		// tabImage
		const tabImage = scene.add.image(0, 0, "hattab");
		this.add(tabImage);

		// disabledCover
		const disabledCover = scene.add.image(0, 0, "shop-tab-m");
		disabledCover.scaleX = 2;
		disabledCover.scaleY = 2;
		disabledCover.alpha = 0.3;
		disabledCover.alphaTopLeft = 0.3;
		disabledCover.alphaTopRight = 0.3;
		disabledCover.alphaBottomLeft = 0.3;
		disabledCover.alphaBottomRight = 0.3;
		disabledCover.tintTopLeft = 0;
		disabledCover.tintTopRight = 0;
		disabledCover.tintBottomLeft = 0;
		disabledCover.tintBottomRight = 0;
		this.add(disabledCover);

		// shopTabNotification
		const shopTabNotification = scene.add.image(22, -12, "hud-icons", 240);
		shopTabNotification.scaleX = 2;
		shopTabNotification.scaleY = 2;
		this.add(shopTabNotification);

		this.tabBacking = tabBacking;
		this.tabImage = tabImage;
		this.disabledCover = disabledCover;
		this.shopTabNotification = shopTabNotification;

		/* START-USER-CTR-CODE */
    this.controller = new ShopTabController(this);
    /* END-USER-CTR-CODE */
	}

	public tabBacking: Phaser.GameObjects.Image;
	public tabImage: Phaser.GameObjects.Image;
	public disabledCover: Phaser.GameObjects.Image;
	public shopTabNotification: Phaser.GameObjects.Image;

	/* START-USER-CODE */

  public controller: ShopTabController;
  public defaultBackingTex: string = `shop-tab-m`;
  public hoverBackingTex: string = `shop-tab-m-hover`;
  public selectedBackingTex: string = `shop-tab-m-selected`;

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
